import { object, string, InferType } from 'yup';

import { damageReportFieldNames } from 'src/pages/DamageReportPage/constants';

export const accidentLocationSchema = object({
  [damageReportFieldNames.detailedDamageDescription]: string().required().nullable(),
});

export type AccidentLocationSchemaType = InferType<typeof accidentLocationSchema>;
